// Move approved SKUs into a project — the picker's remaining strings in the portal's four languages (2026-10-21).
// The rest of the screen already reads `st.mv*` keys.
const en = {
  close: 'Close',
  pickCol: 'Pick',
};

const ko = {
  close: '닫기',
  pickCol: '선택',
};

const vi = {
  close: 'Đóng',
  pickCol: 'Chọn',
};

const zh = {
  close: '关闭',
  pickCol: '选择',
};

const dictionary = { ns: 'xMove', en, ko, vi, zh };

export default dictionary;
